module.exports = __webpack_public_path__ + "static/media/blog-category4.6aafff86.png";